"use client";

import { createContext, useContext, useState, type ReactNode } from "react";

interface HeaderScrollState {
  globalHidden: boolean;
  setGlobalHidden: (hidden: boolean) => void;
}

const HeaderScrollContext = createContext<HeaderScrollState | null>(null);

export function HeaderScrollProvider({ children }: { children: ReactNode }) {
  const [globalHidden, setGlobalHidden] = useState(false);

  return (
    <HeaderScrollContext.Provider value={{ globalHidden, setGlobalHidden }}>
      {children}
    </HeaderScrollContext.Provider>
  );
}

export function useHeaderScroll() {
  const ctx = useContext(HeaderScrollContext);
  if (!ctx) {
    throw new Error(
      "useHeaderScroll must be used within a HeaderScrollProvider",
    );
  }
  return ctx;
}
